var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"name":"file","action":_vm.baseUrl,"on-error":_vm.upError,"show-file-list":false,"headers":_vm.header,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }